export default __webpack_public_path__ + "static/media/location-sign.c75e294f.svg";